document.addEventListener("alpine:init", () => {
  const { apiUrl, apiKey, xAppid, acceptedLanguage } = theme.emailSubscription;

  Alpine.data("cartDpuxEmailSubscribe", () => ({
    email: "",
    errMsg: "",
    loading: false,
    isSuccess: false,
    contactListId: "",

    init() {
      this.contactListId = this.$el.dataset.contactListId;
    },

    async submitEmailForm() {
      const contactListId = this.contactListId;
      this.errMsg = "";

      if (this.email === "") {
        this.errMsg = "Please enter your email address.";
        return;
      }

      const isEmailValid = validateEmail(this.email);
      if (!isEmailValid) {
        this.errMsg = "Please enter a valid email address (Example: name@domain.com)";
        return;
      }

      const subscribeInfoCookie = window.getCookieForEmarsys
        ? window.getCookieForEmarsys("subscribe_info")
        : null;
      let eventTracking = null;

      if (subscribeInfoCookie) {
        try {
          const decodedCookie = decodeURIComponent(subscribeInfoCookie);
          eventTracking = JSON.parse(decodedCookie);
          delete eventTracking.ts;
        } catch (error) {
          console.warn("Failed to parse subscribe_info cookie:", error);
        }
      }

      const fieldsArray = createFieldsArray(dpuxCartEmailSettingJsons);

      const apiBody = {
        email: this.email,
        contactListId,
        fields: fieldsArray,
        ...(eventTracking && { eventTracking }),
      };

      try {
        this.loading = true;
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            apiKey: apiKey,
            traceId: traceId,
            "X-appid": xAppid,
            "Accepted-Language": acceptedLanguage,
          },
          body: JSON.stringify(apiBody),
        });

        const data = await response.json();

        if (data.message === "Success") {
          this.isSuccess = true;
        } else {
          this.errMsg = "Oops... Something went wrong, please refresh and try again.";
        }
      } catch (error) {
        this.errMsg = "Oops... Something went wrong, please refresh and try again.";
        console.error("[cart-dpux-email-subscribe]", error);
      } finally {
        this.loading = false;
      }
    },
  }));
});
